<template lang="pug">
  CrmLeadDetailHistoryUi(
    ref="ui"
    :stages="stages"
    :events="events"
    :leadId="leadId"
    :createdAt="createdAtLabel"
    :currentUserId="currentUserId"
    :canModerate="canModerate"
    :sending="sending"
    @submitComment="addComment"
    @editComment="editComment"
    @removeComment="removeComment"
    )
</template>

<script>
import crmModel from '@/model/crm';
import popupModel from '@/model/popup';
import utils from '@/utils/common';

import crmLeadApi from '@/api/crmLead';

import CrmLeadDetailHistoryUi from '@/components/crm/CrmLeadDetailHistoryUi.vue';

export default {
  name: 'CrmLeadDetailHistoryApi',
  components: { CrmLeadDetailHistoryUi },
  props: {
    leadId: {
      type: [Number, String],
      required: true,
    },
    createdAt: String,
    // этапы воронки для раскраски плашек смены этапа
    stages: {
      type: Array,
      default: () => [],
    },
    // владелец компании и заместитель удаляют любой комментарий
    canModerate: Boolean,
    // смена этапа или ответственного дописывает событие на стороне сервера —
    // родитель меняет этот счётчик, чтобы лента перечиталась
    reloadToken: Number,
  },
  watch: {
    reloadToken() { this.load(); },
  },
  data() {
    return {
      changes: [],
      sending: false,
    };
  },
  created() {
    this.load();
  },
  computed: {
    currentUserId() { return this.$store.state.auth.user?.id ?? null; },
    createdAtLabel() {
      return this.createdAt ? utils.convertDateToString(this.createdAt, 'numeric', true) : '';
    },
    /** Сервер отдаёт ленту свежими вперёд, показываем в обратном порядке. */
    events() {
      return [...this.changes].reverse();
    },
    leadIri() { return crmLeadApi.getIri(this.leadId); },
  },
  methods: {
    async load() {
      this.changes = await crmModel.run(
        () => crmModel.fetchLeadChanges(this.leadId),
        'Не удалось загрузить историю заявки',
      ) ?? [];
    },

    async addComment({ text, files }) {
      this.sending = true;

      const comment = await crmModel.run(
        () => crmModel.createLeadComment({ lead: this.leadIri, text, files }),
        'Не удалось отправить комментарий',
      );

      this.sending = false;
      if (!comment) return;

      this.changes = [comment, ...this.changes];
      this.$refs.ui?.resetForm();
    },

    async editComment({ comment, text }) {
      const updated = await crmModel.run(
        () => crmModel.updateLeadComment(comment.id, text),
        'Не удалось изменить комментарий',
      );
      if (!updated) return;

      const index = this.changes.findIndex(item => item.id === comment.id);
      if (index !== -1) this.$set(this.changes, index, updated);
    },

    async removeComment(comment) {
      const confirmed = await popupModel.addConfirm('Удалить комментарий?');
      if (!confirmed) return;

      const result = await crmModel.run(
        () => crmModel.deleteLeadComment(comment.id),
        'Не удалось удалить комментарий',
      );
      if (result === null) return;

      // сервер добавляет в ленту запись об удалении — перечитываем её целиком,
      // чтобы эта запись появилась
      await this.load();
    },
  },
};
</script>
